export const TOP_LEFT_SASH = 'Top left sash';
export const TOP_RIGHT_SASH = 'Top right sash';
export const BOTTOM_LEFT_SASH = 'Bottom left sash';
export const BOTTOM_RIGHT_SASH = 'Bottom right sash';

export const SASHES_CLASSES = {
    [TOP_LEFT_SASH]: 'isTopLeft',
    [TOP_RIGHT_SASH]: 'isTopRight',
    [BOTTOM_LEFT_SASH]: 'isBottomLeft',
    [BOTTOM_RIGHT_SASH]: 'isBottomRight'
};

const upperFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

export const IMAGE_SELECTOR = 'imageURLs';
export const IMAGE_SELECTOR_MOBILE = 'mobileImageURLs';
export const IMAGE_SELECTOR_GUEST = `guest${upperFirstLetter(IMAGE_SELECTOR)}`;
export const IMAGE_SELECTOR_GUEST_MOBILE = `guest${upperFirstLetter(IMAGE_SELECTOR_MOBILE)}`;

export const IMAGE_SIZE_1X1 = '1x1';
export const IMAGE_SIZE_2X2 = '2x2';

export const DELAY_ACTION = 300;
